// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { RequirePlatformAdmin } from '../shared/auth';
import ProvisioningShell from './components/ProvisioningShell';

/**
 * Route-level entry point, mounted by ProvisioningApp.tsx. Keep it thin:
 * gate, then the shell.
 */
export default function ProvisioningSurface() {
  return (
    <RequirePlatformAdmin>
      <ProvisioningShell />
    </RequirePlatformAdmin>
  );
}
